import { Typography } from "@mui/material";
import { BytesToSize } from "utils/utils";

type PropsType = {
    file: any
    fileValidation: any
    loadsheetStatus: string
}
export default function LoadsheetDataMetaInformation(props: PropsType) {

    
    const {file, fileValidation} = props;
    
    let loadsheetStatus = '';
    if (fileValidation?.is_valid === true ) {
        loadsheetStatus = 'valid';
    }
    if (fileValidation?.is_valid === false) {
        loadsheetStatus = 'in-valid';
    }
    // if (loadsheetStatus == 'failed') {
    //     loadsheetStatus = 'submit-failed';
    // }
    // if (loadsheetStatus == 'completed') {
    //     loadsheetStatus = 'submitted';
    // }
    return (
        <div className='loadsheet-summary'>
            <div className="row mt-3">
                <div className="col-lg-12 d-flex file-information-header">
                    {/* <h4 className='font-size-20pt' >File Information</h4> */}
                    <Typography variant="h4DMSansBold" fontSize={25} marginBottom={2}>File Information</Typography>
                    <div className=' ml-auto' >
                        <span><strong>Status Codes: </strong></span>
                        <span className="badge valid">Valid</span>&nbsp;
                        <span className="badge in-valid">Invalid</span>&nbsp;
                        {/* <span className="badge submitted">Submitted</span>&nbsp; */}
                        {/* <span className="badge submit-failed">Failed to submit</span> */}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 ">
                    <table className="table table-bordered table-hover bg-white">
                        <thead>
                        <tr>
                            <th>File Name</th>
                            <th>Extension</th>
                            <th>File Size</th>
                            <th>Total</th>
                            <th>Valid</th>
                            <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{file?.name}
                            </td>
                            <td>.{file?.name.split(".").pop()}</td>
                            <td>{file && BytesToSize(file?.size, 2)}</td>
                            <td>{file && fileValidation?.total_rows}</td>
                            <td>{file && fileValidation?.total_valid_rows}</td>
                            <td className={loadsheetStatus}>
                                {fileValidation?.is_valid === true &&
                                <span style={{color:'white'}}>Valid</span>}
                                {fileValidation?.is_valid === false &&
                                <span style={{color:'white'}}>Invalid</span>}
                                {/* {submitBtnStatus == 'completed' &&
                                <span style={{color:'white'}}>Submitted</span>}
                                {submitBtnStatus == 'failed' &&
                                <span style={{color:'white'}}>Failed to submit</span>} */}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}